/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReservationExtraText200Response
 */
export interface GetReservationExtraText200Response {
    /**
     * 
     * @type {string}
     * @memberof GetReservationExtraText200Response
     */
    text: string;
}

/**
 * Check if a given object implements the GetReservationExtraText200Response interface.
 */
export function instanceOfGetReservationExtraText200Response(value: object): value is GetReservationExtraText200Response {
    if (!('text' in value) || value['text'] === undefined) return false;
    return true;
}

export function GetReservationExtraText200ResponseFromJSON(json: any): GetReservationExtraText200Response {
    return GetReservationExtraText200ResponseFromJSONTyped(json, false);
}

export function GetReservationExtraText200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationExtraText200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'],
    };
}

export function GetReservationExtraText200ResponseToJSON(json: any): GetReservationExtraText200Response {
    return GetReservationExtraText200ResponseToJSONTyped(json, false);
}

export function GetReservationExtraText200ResponseToJSONTyped(value?: GetReservationExtraText200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
    };
}

